import '../App.css';


function NotFoundPage() {
  return (
    <div className="main">
      <div className="error">
        <p className="error-title">Error 404</p>
        <p>Check if the URL is correct, it seems like we can't find what you're looking for.</p>
      </div>
    </div>
  );
};

export default NotFoundPage;
